import { Outlet } from 'react-router-dom'

function MinimalLayout() {
  return (
    <div>
      <main>
        <Outlet />
      </main>
    </div>
  )
}

export default MinimalLayout
